"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex items-center gap-2" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 2 };
const _hoisted_5 = { class: "flex items-center gap-2" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = ["id"];
const _hoisted_10 = ["data-locale"];
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = { key: 1 };
const _hoisted_13 = { key: 2 };
const _locales_1 = __importDefault(require("../../common/i18n/_locales"));
const DropdownMenu_vue_1 = __importDefault(require("../Navigation/DropdownMenu.vue"));
const DropdownItem_vue_1 = __importDefault(require("../Navigation/DropdownItem.vue"));
const vue_3 = require("vue");
const fetchWrapper_1 = __importDefault(require("../../common/utils/fetchWrapper"));
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const i18n_1 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'LocaleSwitcher',
    props: {
        locales: {
            type: Array,
            required: false,
            default: function () {
                return _locales_1.default;
            }
        },
        dropdown: {
            type: Boolean,
            required: false,
            default: false,
        },
        dropdownRight: {
            type: Boolean,
            required: false,
            default: false,
        },
        dropdownHideCaret: {
            type: Boolean,
            required: false,
            default: false,
        },
        flags: {
            type: Boolean,
            required: false,
            default: false,
        },
        textVariant: {
            type: String,
            required: false,
            default: 'long',
            validator: (value) => ['short', 'long'].indexOf(value) !== -1,
        },
        buttonText: {
            type: Boolean,
            required: false,
            default: false,
        },
        clickable: {
            type: Boolean,
            required: true
        },
        id: {
            type: String,
            default: () => { var _a; return `locale-switcher-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    emits: ['selected'],
    setup(__props, { emit }) {
        const getLocale = () => {
            const savedLocale = localStorage.getItem('selectedLocale');
            if (savedLocale) {
                return setLocale(savedLocale);
            }
            const browserLocale = (navigator.language || navigator.languages[0]).split('-')[0];
            const matchedLocale = _locales_1.default.find((loc) => loc.locale === browserLocale);
            return matchedLocale || _locales_1.default[1];
        };
        const setLocale = (locale) => {
            const matchedLocale = _locales_1.default.find((loc) => loc.locale === locale);
            return matchedLocale || _locales_1.default[1];
        };
        const currentLocale = (0, vue_3.ref)(getLocale());
        const localeChange = (e) => {
            if (!(e.target instanceof HTMLElement)) {
                return false;
            }
            let target = e.target;
            while (target !== null && typeof target.dataset.locale === 'undefined') {
                target = target.parentElement;
            }
            if (target === null || typeof target.dataset.locale === 'undefined') {
                return false;
            }
            const selectedLocale = target.dataset.locale;
            localStorage.setItem('selectedLocale', selectedLocale);
            emit('selected');
            const headers = new Headers({
                'Accept-Language': `${target.dataset.locale},${navigator.languages.join(',')}`
            });
            (0, fetchWrapper_1.default)(`/api/change-locale/${target.dataset.locale}`, { headers: headers })
                .then(response => response.json())
                .then(data => {
                var _a;
                (_a = document.querySelector('html')) === null || _a === void 0 ? void 0 : _a.setAttribute('lang', data.locale);
                ShopConfig_1.ShopConfig.getTranslations()[data.locale] = data.translations[data.locale];
                if (typeof i18n_1.i18n !== 'undefined') {
                    i18n_1.i18n.setLocaleMessage(data.locale, data.translations[data.locale]);
                    i18n_1.i18n.locale.value = data.locale;
                    currentLocale.value = setLocale(i18n_1.i18n.locale.value);
                }
            })
                .catch(e => {
            });
        };
        return (_ctx, _cache) => {
            return (__props.dropdown)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DropdownMenu_vue_1.default, {
                    key: 0,
                    id: __props.id,
                    clickable: __props.clickable
                }, {
                    buttonText: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("span", _hoisted_1, [
                            (__props.flags)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                                    key: 0,
                                    src: 'images/flags/' + currentLocale.value.flag,
                                    alt: currentLocale.value.title,
                                    class: "w-6 shadow-small-box rounded"
                                }, null, 8, _hoisted_2))
                                : (0, vue_2.createCommentVNode)("", true),
                            (__props.buttonText && __props.textVariant == 'long')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_3, (0, vue_2.toDisplayString)(currentLocale.value.title), 1))
                                : (__props.buttonText)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_4, (0, vue_2.toDisplayString)(currentLocale.value.locale), 1))
                                    : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ]),
                    default: (0, vue_2.withCtx)((slotProps) => [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.locales, (locale, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DropdownItem_vue_1.default, {
                                key: index,
                                onSelected: slotProps.itemSelected,
                                "data-locale": locale.locale,
                                onClick: localeChange,
                                class: "cursor-pointer hover:bg-gray"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                        (__props.flags)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                                                key: 0,
                                                src: 'images/flags/' + locale.flag,
                                                alt: locale.title,
                                                class: "w-6 shadow-small-box rounded"
                                            }, null, 8, _hoisted_6))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (__props.textVariant == 'long')
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_7, (0, vue_2.toDisplayString)(locale.title), 1))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_8, (0, vue_2.toDisplayString)(locale.locale), 1))
                                    ])
                                ]),
                                _: 2
                            }, 1032, ["onSelected", "data-locale"]));
                        }), 128))
                    ]),
                    _: 1
                }, 8, ["id", "clickable"]))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 1,
                    id: __props.id
                }, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.locales, (locale, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: index,
                            "data-locale": locale.locale,
                            onClick: localeChange
                        }, [
                            (__props.flags)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                                    key: 0,
                                    src: 'images/flags/' + locale.flag,
                                    alt: locale.title,
                                    class: "w-6 shadow-small-box rounded"
                                }, null, 8, _hoisted_11))
                                : (0, vue_2.createCommentVNode)("", true),
                            (__props.buttonText && __props.textVariant == 'long')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_12, (0, vue_2.toDisplayString)(locale.title), 1))
                                : (__props.buttonText)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_13, (0, vue_2.toDisplayString)(locale.locale), 1))
                                    : (0, vue_2.createCommentVNode)("", true)
                        ], 8, _hoisted_10));
                    }), 128))
                ], 8, _hoisted_9));
        };
    }
});
